export const MYALERTS_SUBSCRIBE_REQUEST = 'MYALERTS_SUBSCRIBE_REQUEST';
export const MYALERTS_SUBSCRIBE_SUCCESS = 'MYALERTS_SUBSCRIBE_SUCCESS';
export const MYALERTS_SUBSCRIBE_ERROR = 'MYALERTS_SUBSCRIBE_ERROR';
export const MYALERTS_CLEAR_DATA = 'MYALERTS_CLEAR_DATA';
export const MYALERTS_LOADER = 'MYALERTS_LOADER';
